import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type ApiKeysQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
}>;

export type ApiKeysQueryResult = { __typename?: 'Query' } & {
  account?: GraphQLTypes.Maybe<
    { __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id'> & {
        ssoDetails: { __typename?: 'SsoDetails' } & {
          apiKeys: Array<{ __typename?: 'ScimApiKey' } & Pick<GraphQLTypes.ScimApiKey, 'expiryDate' | 'id' | 'status'>>;
        };
      }
  >;
};

export const ApiKeysDocument = gql`
  query apiKeys($accountId: String!) {
    account(accountId: $accountId) {
      id
      ssoDetails {
        apiKeys {
          expiryDate
          id
          status
        }
      }
    }
  }
`;
